const internals = {};

exports.startCordovaOfflineSimulation = ({ http } = {}) => {

    const connection = globalThis.navigator?.connection;

    if (!connection || !http?.interceptors?.request?.use) {
        return false;
    }

    exports.stopFailureSimulation();

    const originalDescriptor = Object.getOwnPropertyDescriptor(connection, 'type');
    const originalType = connection.type;

    try {
        Object.defineProperty(connection, 'type', {
            configurable: true,
            value: globalThis.Connection?.NONE || 'none'
        });
    }
    catch (error) {
        return false;
    }

    const interceptRequest = (config) => {

        if (config.url !== '/ping') {
            return config;
        }

        return Promise.reject(internals.createError(config, { code: 'ERR_NETWORK' }));
    };
    const interceptorId = http.interceptors.request.use(interceptRequest);
    const restore = () => {

        http.interceptors.request.eject(interceptorId);

        if (originalDescriptor) {
            Object.defineProperty(connection, 'type', originalDescriptor);
        }
        else {
            delete connection.type;

            if (connection.type !== originalType) {
                Object.defineProperty(connection, 'type', {
                    configurable: true,
                    value: originalType
                });
            }
        }

        document.dispatchEvent(new Event('online'));
    };

    internals.activeSimulation = {
        cleanup: restore,
        timer: setTimeout(exports.stopFailureSimulation, 10_000)
    };

    document.dispatchEvent(new Event('offline'));

    return true;
};

exports.startRequestFailureSimulation = ({ http, scenario }) => {

    const simulation = internals.scenarios[scenario];

    if (!simulation || !http?.interceptors?.request?.use) {
        return false;
    }

    exports.stopFailureSimulation();

    const { failures, pairWithRetry } = simulation;
    const simulationId = ++internals.simulationId;
    let attempt = 0;
    let interceptorId;

    const cleanup = () => http.interceptors.request.eject(interceptorId);
    const interceptRequest = (config) => {

        if (config.serviceUnavailableRetry !== true) {
            return config;
        }

        if (pairWithRetry && attempt === 0 && config.serviceUnavailableAttempt) {
            return config;
        }

        if (pairWithRetry && attempt > 0 && (
            config[internals.simulationMarker] !== simulationId
            || config.serviceUnavailableAttempt !== 1
        )) {
            return config;
        }

        if (pairWithRetry && attempt === 0) {
            config[internals.simulationMarker] = simulationId;
        }

        const failure = failures[attempt];

        ++attempt;

        if (attempt === failures.length) {
            exports.stopFailureSimulation();
        }

        if (!failure) {
            return config;
        }

        return Promise.reject(internals.createError(config, failure));
    };

    interceptorId = http.interceptors.request.use(interceptRequest);
    internals.activeSimulation = {
        cleanup,
        timer: setTimeout(exports.stopFailureSimulation, 60_000)
    };

    return true;
};

exports.stopFailureSimulation = () => {

    const activeSimulation = internals.activeSimulation;

    if (!activeSimulation) {
        return false;
    }

    internals.activeSimulation = null;
    clearTimeout(activeSimulation.timer);
    activeSimulation.cleanup();

    return true;
};

internals.activeSimulation = null;
internals.simulationId = 0;
internals.simulationMarker = '_nearpeerFailureSimulationId';

internals.scenarios = {
    'internal-server-error': {
        failures: [
            { status: 500 },
            null
        ]
    },
    'gateway-failure': {
        failures: [
            { status: 502 },
            { status: 504 }
        ],
        pairWithRetry: true
    },
    'heavy-traffic': {
        failures: [
            { status: 503 },
            { status: 503 }
        ],
        pairWithRetry: true
    },
    'intermittent-503': {
        failures: [
            { status: 503 },
            null
        ]
    },
    maintenance: {
        failures: [{
            data: {
                message: 'Nearpeer is temporarily down for maintenance.',
                status: 'downtime'
            },
            status: 503
        }]
    },
    'transport-abort': {
        failures: [
            { code: 'ERR_ABORTED' },
            { code: 'ERR_ABORTED' }
        ],
        pairWithRetry: true
    }
};

internals.createError = (config, failure) => {

    const error = new Error(failure.code ? 'Request aborted' : `Request failed with status code ${failure.status}`);

    error.code = failure.code;
    error.config = config;
    error.isAxiosError = true;

    if (failure.status) {
        error.response = {
            config,
            data: failure.data || {},
            headers: {},
            status: failure.status,
            statusText: 'Service Unavailable'
        };
    }

    return error;
};
